import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.min.css'
import 'bootstrap-icons/font/bootstrap-icons.css'
import './assets/dashboard.css'
import './assets/dashboard.rtl.css'
import './assets/style1.css'

import VCalendar from 'v-calendar'
import 'v-calendar/dist/style.css'

import { library } from '@fortawesome/fontawesome-svg-core'
import { faUserSecret } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret)
    
createApp(App).use(router).use(VCalendar, {}).component("font-awesome-icon" ,FontAwesomeIcon).mount('#app')